import { lazy } from 'react';

// The platform theme sources pull in the Teams and Zoom SDKs, so they load only
// when the error page is shown inside that platform.
export const TeamsErrorThemeRegistry = lazy(() =>
  import('./TeamsErrorThemeRegistry').then((m) => ({
    default: m.TeamsErrorThemeRegistry,
  })),
);

export const ZoomThemeRegistry = lazy(() =>
  import('./ZoomThemeRegistry').then((m) => ({ default: m.ZoomThemeRegistry })),
);
